import { FGTN_SITE_ORIGIN, isSafeHref } from './fgtn';

function toUrl(href) {
  try {
    return new URL(String(href).trim(), window.location.origin || FGTN_SITE_ORIGIN);
  } catch {
    return null;
  }
}

function hostOf(url) {
  return String(url.hostname || '').replace(/^www\./i, '').toLowerCase();
}

function isAnglerBuiltUrl(url) {
  const host = hostOf(url);
  return host === 'anglerbuilt.com' || host === 'localhost' || host.endsWith('.localhost');
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent || '');
}

function isIOS() {
  const ua = navigator.userAgent || '';
  return /iPhone|iPad|iPod/i.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function isStandaloneApp() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

function isInAppBrowser() {
  const ua = navigator.userAgent || '';
  return /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|Snapchat|TikTok|musical_ly|Bytedance|Pinterest|LinkedInApp|WhatsApp|Messenger|MicroMessenger/i.test(ua);
}

function isTrappedBrowser() {
  return isStandaloneApp() || isInAppBrowser();
}

function androidIntentUrl(url) {
  const fallback = encodeURIComponent(url.href);
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${url.protocol.replace(':', '')};S.browser_fallback_url=${fallback};end`;
}

function nativeAppUrl(url) {
  const host = hostOf(url);
  const parts = url.pathname.replace(/\/+$/, '').split('/').filter(Boolean);

  if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
    if (host === 'youtu.be' && parts[0]) {
      return `youtube://www.youtube.com/watch?v=${encodeURIComponent(parts[0])}${url.search}`;
    }
    return `youtube://${url.host}${url.pathname}${url.search}`;
  }

  if (host === 'instagram.com') {
    if ((parts[0] === 'p' || parts[0] === 'reel' || parts[0] === 'reels' || parts[0] === 'tv') && parts[1]) {
      return `instagram://media?shortcode=${encodeURIComponent(parts[1])}`;
    }
    if (parts[0] && !['explore', 'accounts', 'direct', 'stories'].includes(parts[0])) {
      return `instagram://user?username=${encodeURIComponent(parts[0])}`;
    }
    return 'instagram://app';
  }

  if (host === 'facebook.com' || host === 'fb.com' || host === 'fb.watch' || host === 'm.facebook.com') {
    return `fb://facewebmodal/f?href=${encodeURIComponent(url.href)}`;
  }

  if (host === 'x.com' || host === 'twitter.com') {
    if (parts[1] === 'status' && parts[2]) {
      return `twitter://status?id=${encodeURIComponent(parts[2])}`;
    }
    if (parts[0] && parts[0] !== 'i' && parts[0] !== 'intent') {
      return `twitter://user?screen_name=${encodeURIComponent(parts[0])}`;
    }
    return `twitter://${url.host}${url.pathname}${url.search}`;
  }

  if (host === 'amazon.com' || host === 'amazon.ca' || host === 'smile.amazon.com') {
    return `com.amazon.mobile.shopping.web://${url.host}${url.pathname}${url.search}`;
  }

  return null;
}

function openNativeThenHttps(nativeUrl, httpsUrl) {
  let handedOff = false;
  const markHandedOff = () => {
    handedOff = true;
  };
  window.addEventListener('pagehide', markHandedOff, { once: true });
  window.addEventListener('blur', markHandedOff, { once: true });

  window.location.assign(nativeUrl);
  window.setTimeout(() => {
    if (!handedOff && !document.hidden) {
      window.location.assign(httpsUrl);
    }
  }, 900);
}

export function handleFgtnNotesClick(event) {
  if (event.defaultPrevented) return;
  if (event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const root = event.currentTarget;
  const anchor = event.target.closest('a[href]');
  if (!anchor || !root.contains(anchor)) return;

  const href = anchor.getAttribute('href');
  if (!isSafeHref(href)) return;

  const url = toUrl(href);
  if (!url || (url.protocol !== 'http:' && url.protocol !== 'https:')) return;
  if (isAnglerBuiltUrl(url)) return;

  if (!isAndroid() && !isIOS()) {
    event.preventDefault();
    window.open(url.href, '_blank', 'noopener,noreferrer');
    return;
  }

  // Camera / Safari / Chrome: let the real tap through so iOS Universal Links
  // and Android App Links can open YouTube, Instagram, Amazon, etc.
  if (!isTrappedBrowser()) return;

  event.preventDefault();

  if (isAndroid()) {
    window.location.assign(androidIntentUrl(url));
    return;
  }

  const appUrl = nativeAppUrl(url);
  if (appUrl) {
    openNativeThenHttps(appUrl, url.href);
    return;
  }

  window.location.assign(url.href.replace(/^https:\/\//i, 'x-safari-https://'));
  window.setTimeout(() => {
    if (!document.hidden) window.location.assign(url.href);
  }, 400);
}
